import { SpateAiIcon } from '@/ui/design-system/components/ui/spate-ai-icon';
import UseCasePills from './UseCasePills';

const WelcomeScreen = ({ firstName, onSelectUseCase }) => (
    <div className="flex-1 flex flex-col items-center justify-center px-4 py-6 gap-4">
        <div className="flex items-center justify-center w-16 h-16 rounded-lg bg-muted text-primary">
            <SpateAiIcon size={32} />
        </div>
        <div className="text-center space-y-1">
            <div className="text-xl font-medium text-card-foreground m-0 capitalize">
                Hi, {firstName}
            </div>
            <div className="text-base font-semibold text-card-foreground m-0">
                Can I help you with anything?
            </div>
            <div className="text-sm text-muted-foreground m-0">
                Ask about trends, brands, ingredients, or navigate the
                dashboard.
            </div>
        </div>
        <UseCasePills
            onSelect={onSelectUseCase}
            className="mt-2 justify-center"
        />
    </div>
);

export default WelcomeScreen;
